<template>
  <div class="video_viewer">
    <!-- <video class="video_box" :src="videoPath"></video> -->
    <video class="video_box" controls="" autoplay="" name="media" playsinline>
      <source :src="videoPath" type="video/mp4" />
    </video>
    <!-- <iframe class="iframe_box" :src="videoPath"></iframe> -->

    <div class="closeBtn" @click="close"></div>
  </div>
</template>

<script>
export default {
  name: 'video_viewer',
  data() {
    return {}
  },
  props: {
    videoPath: String,
    sourseType: Number
  },
  mounted() {
    this.$EventBus.$emit('hasHome', false)
  },
  methods: {
    close() {
      this.$parent.viedeoShow = false
      this.$EventBus.$emit('hasHome', true)
    }
  }
}
</script>

<style lang='scss' scoped>
.video_viewer {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;
  background-color: #414141 !important;

  .video_box {
    width: 100%;
  }
  .closeBtn {
    position: absolute;
    bottom: 2rem;
    left: 0;
    right: 0;
    margin: auto;
    width: 1.1rem;
    height: 1.1rem;
    background-image: url('~@/assets/img/picture-close.png');
    background-size: 100% 100%;
  }
}
</style>